import { z } from "zod";

export const favoritesSchema = z.object({
	id: z.string(),
	nameEn: z.string().trim().min(1),
	nameAr: z.string().trim().min(1),
});
